import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RaAccountingStatus } from '@work4all/models/lib/Enums/RaAccountingStatus.enum';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

type Props<TMultiple extends boolean> = IPickerProps<
  { id: string; name: string },
  TMultiple
>;

export function RaAccountingStatusPicker<TMultiple extends boolean>(
  props: Props<TMultiple>
) {
  const { t } = useTranslation();
  const data = useMemo(() => {
    return Object.keys(RaAccountingStatus)
      .map((key) => {
        const id = RaAccountingStatus[key];

        return {
          id,
          name: t(`RA.ACCOUNTING_STATUSES.${id}`),
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [t]);

  return <FixedDataPicker dataSet={data} {...props} />;
}
